module.exports = __webpack_public_path__ + "static/project-14a-acee19378f6a195b6621ddff6b14a28f.png";